import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex items-center flex-wrap gap-1 font-body font-semibold text-sm text-charcoal/60">
      {items.map((it, i) => (
        <span key={i} className="inline-flex items-center gap-1">
          {i > 0 && <ChevronRight className="w-4 h-4 text-charcoal/40" />}
          {it.to ? <Link to={it.to} className="inline-block py-2 hover:text-coral">{it.label}</Link> : <span className="text-charcoal">{it.label}</span>}
        </span>
      ))}
    </nav>
  );
}

export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: it.to ? `https://skedaddlejunk.com${it.to}` : undefined,
    })),
  };
}
